import React from 'react';
import PropTypes from 'prop-types';
import Radium from 'radium';
// import moment from 'moment';

import ProjectImageElement from '../ProjectImageElement';
import ProjectDetailsList from './ProjectDetailsList';
import Styles from './ProjectDetails.styles';
import ChangeHistoryBox from './ChangeHistoryBox';
import JumperScrollbar from '../../JumperScrollbar/JumperScrollbar';
import ProjectDetailsHeader from './ProjectDetailsHeader';
import ProjectEditButton from '../ProjectEditButton';

const ProjectDetails = (props) => {
  const {
    name,
    createdAt,
    updatedAt,
    isPrivate,
    link,
    owners,
    image,
    description,
    history,
    auth,
  } = props;

  const { downloadURL = null } = image || {};
  return (
    <JumperScrollbar
      style={{ display: 'block' }}
      thumbStyle={{
        backgroundColor: 'rgb(145,153,154)',
        width: '10px',
        cursor: 'pointer',
      }}
    >
      <div style={Styles.wrapper}>
        <div style={Styles.columnWrapper}>
          <div style={Styles.headline}>Project details </div>
          <ProjectDetailsList {...{ name, createdAt, updatedAt, isPrivate, link, owners }} />
        </div>
        <div style={Styles.columnWrapper}>
          <div style={{ flex: '0 0 50%', overflow: 'hidden' }}>
            <div style={Styles.imageWrapper}>
              <ProjectImageElement
                alt=""
                imageUrl={downloadURL}
                spinnerStyle={{ color: 'white' }}
                containerStyle={{
                  width: 'auto',
                  height: '200px',
                }}
              />
            </div>
            {description && (
              <div style={Styles.description}>
                <ProjectDetailsHeader text="Description" />
                <div>{description}</div>
              </div>
            )}
          </div>
          <ChangeHistoryBox history={history} auth={auth} />
        </div>
      </div>
    </JumperScrollbar>
  );
};

ProjectDetails.defaultProps = {
  updatedAt: '',
  isPrivate: false,
  link: '',
  owners: null,
  description: '',
  image: '',
  history: null,
};

ProjectDetails.propTypes = {
  name: PropTypes.string.isRequired,
  createdAt: PropTypes.number.isRequired,
  updatedAt: PropTypes.string,
  isPrivate: PropTypes.bool,
  link: PropTypes.string,
  owners: PropTypes.arrayOf(Object),
  description: PropTypes.string,
  image: PropTypes.string,
  history: PropTypes.arrayOf(Object),
  auth: PropTypes.shape().isRequired,
};

export default Radium(ProjectDetails);



// WEBPACK FOOTER //
// ./src/components/Project/ProjectDetails/ProjectDetails.js